import { BaseModel, fillOwnProperties } from '~/shared/model'
import { API_PREFIX } from '~/shared/const/request-services'
import { isNonEmptyString, isUnknownObject } from '~/shared/utils/guards'

const VIDEO_URL = `${API_PREFIX}/videos/get`

export default class LandingVideoBlock extends BaseModel {
  static override constructorName = 'LandingVideoBlock'

  readonly name = 'video_block'

  title: string = ''
  file: string = ''
  url: string = ''
  'video_type': string = ''

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data, ['file', 'video_type'])

      this.file = isNonEmptyString(data.file) ? `${VIDEO_URL}?url=${data.file}` : ''
      this.video_type = String(data.video_type ?? '')
    }
  }
}
